import { unionBy } from 'lodash';

const DEFAULT_FILTERS = {
  coursePageSize: 25,
  schoolFilter: null,
  isEditable: false,
  courseSearch: '',
  courseFilter: {},
  isAllCoursesExpanded: false,
  courseBusy: false,
  coursePage: 0,
  courseCount: 0,
  courseListMDPages: [],
};

const DEFAULT_STATE = {
  courseListContext: null,
  courseList: [],
  catalogContext: null,
  districtConfig: null,
  ...DEFAULT_FILTERS,
};

export default (state = DEFAULT_STATE, { type, ...rest }) => {
  switch (type) {
    case 'PUBLIC_COURSE_CATALOG/SET_COURSE_LIST_CONTEXT':
      return {
        ...state,
        courseListContext: rest.courseListContext,
      };

    case 'PUBLIC_COURSE_CATALOG/TOGGLE_COURSE_BUSY':
      return {
        ...state,
        courseBusy: !state.courseBusy,
      };

    case 'PUBLIC_COURSE_CATALOG/SET_COURSE_BUSY':
      return {
        ...state,
        courseBusy: rest.courseBusy,
      };

    case 'PUBLIC_COURSE_CATALOG/RESET_COURSES':
      return {
        ...state,
        courseList: rest.results,
        courseCount: rest.count,
        coursePage: 1,
        courseListMDPages: rest?.pages ?? [],
      };

    case 'PUBLIC_COURSE_CATALOG/MERGE_COURSES':
      return {
        ...state,
        courseList: unionBy(state.courseList, rest.results, 'uuid'),
        courseCount: rest.count,
        coursePage: state.coursePage + 1,
        courseListMDPages: rest?.pages ?? [],
      };

    case 'PUBLIC_COURSE_CATALOG/TOGGLE_EXPANSION':
      return {
        ...state,
        isAllCoursesExpanded: !state.isAllCoursesExpanded,
      };

    case 'PUBLIC_COURSE_CATALOG/SET_COURSE_SEARCH':
      return {
        ...state,
        courseSearch: rest.courseSearch,
      };

    case 'PUBLIC_COURSE_CATALOG/SET_COURSE_FILTER':
      return {
        ...state,
        courseFilter: rest.courseFilter,
      };

    case 'PUBLIC_COURSE_CATALOG/SET_CATALOG_CONTEXT':
      return {
        ...state,
        catalogContext: rest.catalogContext,
      };

    case 'PUBLIC_COURSE_CATALOG/SET_DISTRICT_CONFIG':
      return {
        ...state,
        districtConfig: {
          ...state.districtConfig,
          ...rest.districtConfig,
        },
      };

    case 'PUBLIC_COURSE_CATALOG/SET_SCHOOL_FILTER':
      return {
        ...state,
        schoolFilter: rest.schoolFilter,
      };

    case 'PUBLIC_COURSE_CATALOG/SET_IS_EDITABLE':
      return {
        ...state,
        isEditable: rest.isEditable,
      };

    case 'PUBLIC_COURSE_CATALOG/RESET_COURSE_LIST':
      return {
        ...state,
        ...DEFAULT_FILTERS,
      };

    case 'PUBLIC_COURSE_CATALOG/EMPTY_COURSE_LIST':
      return {
        ...state,
        courseList: [],
      };

    default:
      return state;
  }
};
